export const breakpoints = [480, 960, 1024, 1440]
export const size = {
  mobile: breakpoints[0],
  small: breakpoints[1],
  medium: breakpoints[2],
  large: breakpoints[3],
}
